import React from 'react'
import './LoadingModal.css'
const LoadingModal = () => {
  return (
    
    <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_Stt1R6.json"  background="transparent" class="modal-logo-main"  speed="1"  style={{width: "300px", height: "300px"}}  loop autoplay></lottie-player>
    
    
  )
}

export default LoadingModal